module.exports = {"540325100":"烟多镇","540325101":"吉塘镇","540325102":"香堆镇","540325200":"宗沙乡","540325201":"肯通乡","540325202":"扩达乡","540325203":"新卡乡","540325204":"王卡乡","540325205":"阿孜乡","540325206":"巴日乡","540325207":"荣周乡","540325208":"卡贡乡","540325209":"察拉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540325.json
// module id = 2514
// module chunks = 0